import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { consumeSsoTicket } from './app/services/sso';


// เข้ามาจาก Module-Pos-Admin พร้อม #sso=<ticket> → แลกเป็น token ก่อน bootstrap (ไม่ต้อง login ซ้ำ)
consumeSsoTicket()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
